import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'tr-loading-overlay',
    template: `<div id="loading-overlay" class="loading-overlay" *ngIf="loading">
                    <div class="loading-overlay-box">
                        <svg-icon icon="icon_loading" iconClass="spin"></svg-icon>
                    </div>
                </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrLoadingOverlay {
    @Input() public loading: boolean;
}
